<div appDragClose [dragThreshold]="100" (dragClose)="closeOffcanvas()">
  <div class="drag-handle">
    <div class="drag-indicator"></div>
  </div>
  <div class="offcanvas-header">
    <h5 id="offcanvasLabel" class="mb-0">{{ title }}</h5>
    <button type="button" class="btn-close no-drag" (click)="closeOffcanvas()"></button>
  </div>
</div>
<div ngbAutoFocus
  [ngClass]="(type === 'country' || type === 'region' || type === 'district') ? 'pt-1 with-separators' : 'offcanvas-content'">
  <ul *ngIf="type === 'region'" (click)="onSelect(undefined)" data-bs-dismiss="offcanvas"
    class="list-group border-bottom">
    <li class="list-group-item d-flex flex-row align-items-center with-separators">
      <i class="bi bi-list me-2"></i>
      <span>
        {{ 'all_f' | translate}}
      </span>
    </li>
  </ul>
  <ul *ngFor="let item of items" (click)="onSelect(item)" data-bs-dismiss="offcanvas" class="list-group border-bottom"
    [ngClass]="{'with-separators': type === 'country' || type === 'region' || type === 'district'}">
    <li [ngSwitch]="type" class="list-group-item d-flex flex-row align-items-center ">
      <i *ngSwitchCase="'country'" class="bi bi-geo-alt me-2"></i>
      <div *ngSwitchCase="'region'">
        <app-country-list [region]="item.name | placeName"
          [country]="searchFlow.selectedCountry?.code | countryName : searchFlow.selectedCountry?.name"></app-country-list>
      </div>
      <i *ngSwitchCase="'district'" class="bi bi-geo-alt"></i>
      <div *ngSwitchCase="'language'">
        <img *ngIf="item.code!='' && item.code!=='wl'" [src]="Utils.getFlagSrc(item.code)" class="flag-icon me-2"
          alt="{{ Utils.getFlagName(item.code) | translate }} flag" [title]="Utils.getFlagName(item.code) | translate"
          [attr.aria-label]="Utils.getFlagName(item.code) | translate">
        <img *ngIf="item.code=='wl'" [src]="Utils.getFlagSrc(item.code)" class="flag-world me-2"
          alt="{{ Utils.getFlagName(item.code) | translate }} flag" [title]="Utils.getFlagName(item.code) | translate"
          [attr.aria-label]="Utils.getFlagName(item.code) | translate">
      </div>
      <span class="country-name" *ngIf="type === 'country'">
        {{ item.code | countryName : item.name }}
      </span>
      <span *ngIf="type !== 'region' && type !== 'order' && type !== 'country'">
        {{ (item.name | translate) || item }}
      </span>

      <span *ngIf="type == 'order'" class="d-flex align-items-center justify-content-start w-100 gap-2">
        <i [ngClass]="item.icon"></i>
        {{ item.name | translate }}
      </span>

      <input *ngIf="type === 'language' || type === 'order'" class="form-check-input ms-auto checkbox" type="radio"
        name="flexRadioDefault" id="flexRadioDefault2"
        [checked]="type === 'language' ? selectedItem === item.code : selectedItem === item.orderBy+'-'+item.direction"
        (click)="onSelect(item); $event.stopPropagation()">

    </li>
  </ul>
</div>